import qs from 'qs';

export default class QueryString {
  static parse(value) {
    return qs.parse(value, { ignoreQueryPrefix: true });
  }

  static stringify(value) {
    return qs.stringify(value, { strictNullHandling: true });
  }
}
